import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { auth } from "../../firebase";
import { applyActionCode } from "firebase/auth";

export default function EmailActionHandler() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    const mode = params.get("mode");
    const oobCode = params.get("oobCode");
    const continueUrl = params.get("continueUrl") || "/post-payment?verified=1";

    // We only handle verifyEmail here. (You can extend later for password reset, etc.)
    if (mode !== "verifyEmail" || !oobCode) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        // Mark the email as verified in Firebase Auth
        await applyActionCode(auth, oobCode);
           try {
          await applyActionCode(auth, oobCode);
        } catch (e) {
          // If the code was already used (because Firebase handled it before redirecting
          // to us), treat it as success instead of blocking the user.
          if (e?.code === "auth/invalid-action-code") {
            setDone(true);
          } else {
            throw e;
          }
        }

        // Refresh the current user (if logged in) so emailVerified becomes true in the client
        try {
          if (auth.currentUser) {
            await auth.currentUser.reload();
            await auth.currentUser.getIdToken(true);
          }
        } catch {}

        setDone(true);
        // Small pause for the user to see success, then continue
        setTimeout(() => navigate(continueUrl, { replace: true }), 700);
      } catch (e) {
        setErr(e && e.message ? e.message : String(e));
      }
    })();
  }, [navigate, params]);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 20 }}>
      <div style={{ width: "100%", maxWidth: 520, background: "#fff", borderRadius: 14, boxShadow: "0 10px 40px #2a05161a", padding: 28 }}>
        <div style={{ textAlign: "center", marginBottom: 12 }}>
          <img src="/Lastwishbox-logo.png" alt="LastWish Box" style={{ height: 36 }} />
        </div>
        <h2 style={{ marginTop: 0, color: "#2a0516" }}>Verifying your email…</h2>

        {!err && !done && (
          <p style={{ marginTop: 8 }}>Please wait a moment while we confirm your email address.</p>
        )}

        {done && (
          <p style={{ marginTop: 8, color: "#065f46" }}>
            Your email has been verified. Redirecting…
          </p>
        )}

        {err && (
          <>
            <div style={{ marginTop: 8, color: "#7a0b0b", background: "#fee2e2", border: "1px solid #fecaca", padding: "10px 12px", borderRadius: 8 }}>
              {err}
            </div>
            <div style={{ marginTop: 12 }}>
              <button
                onClick={() => navigate("/", { replace: true })}
                style={{ height: 38, padding: "0 14px", borderRadius: 10, border: "1px solid #d6d6e7", background: "#fff", cursor: "pointer" }}
              >
                Go to Login
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
